// export const EcomAPI = "https://ajeeviecom.ajeevi.in";

export const CMSAPI = "https://moduleapi.ajeevi.in";